import { makeStyles, Dialog, useMediaQuery, DialogContent, Typography } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';
import { Timeslots } from '../Reschedule/Timeslots';
import moment from "moment-timezone";
import { isJourneyVisibleState } from '..';
import { useRecoilState } from 'recoil';
import { TimeslotsV2 } from '../Reschedule/TimeslotsV2';
const useStyles = makeStyles(theme => {
  return {
    root: {
      alignSelf: 'center',
      textAlign: 'center',
      paddingBottom: theme.spacing(4),
      marginTop: theme.spacing(-4),
    },
    lottie: {
      height: 200
    },
    contentTitle: {
      lineHeight: '2em',
      paddingBottom: theme.spacing(2)
    },
    contentSubtext: {
      lineHeight: '2em',
      paddingBottom: theme.spacing(3)
    },
    loc_scrollPaper: {
      [theme.breakpoints.down("xs")]: {
        height: "75vh",
        overflowY: "scroll",

      },
    },
    loc_container: {
      [theme.breakpoints.down("xs")]: {

      },
    },
    loc_dialog: {
      "z-index": `${theme.zIndex.modal - 1} !important `,
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        display: "flex",
        justifyContent: "flex-end",
      },
    },
    loc_paper: {
      display: "flex",
      flexDirection: "column",
      textAlign: "center",
    },
    dialogContent: {
      height: 'auto',
      flex: '0 0 auto'
    },
    offsetPaper: {
      top: theme.spacing(5),
    },
    offsetScrollBody: {
      verticalAlign: 'top'
    },
  }
});
const ScheduleConfirmationDialog = ({ confirmContext, booking, asDialog = true }) => {
  const classes = useStyles()
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });

  const [isJourneyVisible, setIsJourneyVisible] = useRecoilState(isJourneyVisibleState);
  const content = useMemo(
    () => {
      return <TimeslotsV2
        view="Set Schedule"
        inline
        serviceId={booking?.id}
        oldTime={booking?.date_scheduled}
        booking={booking}
        asNewTimeslot
        maxDate={moment.utc(booking?.date_scheduled).toDate()}
        minDate={moment().add(1, 'days').startOf('day').toDate()}
        autoConfirm={false}
      />
    }, [booking]
  );

  if (asDialog) {
    return (
      <Dialog
        open
        keepMounted
        maxWidth="md"
        disableEnforceFocus
        className={classes.loc_dialog}
        classes={{
          paper: classes.dialogRoot,
          paperScrollPaper: isJourneyVisible && classes.offsetPaper,
          paperScrollBody: isJourneyVisible && classes.offsetScrollBody,
        }}
      >
        <DialogContent className={classes.dialogContent}>
          <Typography variant='h4' className={classes.contentTitle}>
            Set your preferred booking time
          </Typography>
          {content}
        </DialogContent>
      </Dialog>
    )
  } else {
    return (
      <>
        <Typography variant='h4' className={classes.contentTitle}>
          Set your preferred booking time
        </Typography>
        {content}
      </>
    )
  }

}

export { ScheduleConfirmationDialog }